import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { CancellationNotesPageRoutingModule } from './cancellation-notes-routing.module';

import { CancellationNotesPage } from './cancellation-notes.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    CancellationNotesPageRoutingModule
  ],
  declarations: [CancellationNotesPage]
})
export class CancellationNotesPageModule {}
